import { useEffect } from 'react';
import '../css/bg.css';
import Red from '../Components/Assets/red.svg';
import Background from '../Components/background/background';
import BackgruseRedirectIfNotLoggedIn from '../Components/redirect/redirect';
import { useLocation, useNavigate } from "react-router-dom";
import { checkTokenAndNavigate } from "../Utils/login";

const UnauthPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { openedViaLogin = false } = location.state || {};

    BackgruseRedirectIfNotLoggedIn(openedViaLogin);

    useEffect(() => {
        checkTokenAndNavigate(navigate)
    }, [ navigate]);

    return (
        <div className="relative h-screen w-screen bg-white-200  overflow-hidden">
            {/* Animated Background */}
            <Background />

            {/* Centered Login Box */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="z-10 bg-white shadow-lg rounded-lg p-8 flex flex-col items-center">
                    {/* Logo */}
                    <img
                        src={Red}
                        alt="Unauthorized Access"
                        className="w-24 h-auto mb-6"
                    />
                    <h1 className="text-2xl font-bold text-black mb-4">Unauthorized</h1>
                    <p className="text-lg text-red-600">Contact your IT team for access.</p>

                </div>
            </div>
        </div>
    );
};

export default UnauthPage;



